import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';

export default function Home() {
  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold mb-3">Welcome to Excelsior Collectibles</h1>
        <p className="lead mb-4">Experience exclusive VIP benefits with our unique NFT collection</p>
        <div className="d-flex gap-3 justify-content-center">
        <Link to="/gallery" className="text-decoration-none">
          <Button variant="primary" size="lg" className="me-2">
            View My NFTs
          </Button>
        </Link>
          <Button variant="outline-primary" size="lg">
            Learn More
          </Button>
        </div>
      </div>

      <Row className="g-4">
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm">
            <Card.Body className="text-center p-4">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi bi-gem fs-3 text-primary"></i>
              </div>
              <h3>Exclusive Access</h3>
              <p className="text-muted">Gain access to premium hotel amenities and services with your NFT.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm">
            <Card.Body className="text-center p-4">
              <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi bi-stars fs-3 text-success"></i>
              </div>
              <h3>VIP Benefits</h3>
              <p className="text-muted">Enjoy special discounts, upgrades, and personalized services.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm">
            <Card.Body className="text-center p-4">
              <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi-shield-check fs-3 text-warning"></i>
              </div>
              <h3>Secure Ownership</h3>
              <p className="text-muted">Your digital assets are securely stored on the blockchain.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="text-center mt-5 pt-5">
        <h2 className="mb-4">Ready to get started?</h2>
        <p className="lead mb-4">Connect your wallet to view your NFT collection and unlock exclusive benefits.</p>
        <Link to="/nft-gallery" className="text-decoration-none">
          <Button variant="primary" size="lg" className="me-2">
            View My NFTs
          </Button>
        </Link>
      </div>
    </Container>
  );
}
